<div class="exam-experience-popup">
    <button class="pop-cls-btn" (click)="close()"><img src="assets/img/detail-close-icon.svg" class="icon" /></button>
    <form #reviewform="ngForm" class="feedback-form">
        <div>
            <h4 class="assessment_pb-25 exam-experience-popup-hdng">How was your experience?</h4>

            <!-- <h4 class="assessment_pb-25">Great! Can you help you with your feedback?</h4> -->
            <!-- <p>1. Rate the difficulty level of the test</p> -->
            
            <!-- <p>2. Check all the options you faced difficulty with</p> -->
            <!-- <p>2. How was the test taking experience?</p> -->
            <div class="assessment_mb-30">
                <!-- <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input"
                        [(ngModel)]="reviewForm.difficultylevelOptions.Buffering" [ngModelOptions]="{standalone: true}" id="customCheck1">
                    <label class="custom-control-label" for="customCheck1">Buffering</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="customCheck2" [(ngModel)]="reviewForm.difficultylevelOptions['Internet Issue']" [ngModelOptions]="{standalone: true}">
                    <label class="custom-control-label" for="customCheck2">Internet Issue</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="customCheck3" [(ngModel)]="reviewForm.difficultylevelOptions['Test did not load']" [ngModelOptions]="{standalone: true}">
                    <label class="custom-control-label" for="customCheck3">Test did not load</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="customCheck4" [(ngModel)]="reviewForm.difficultylevelOptions['Images did not load']" [ngModelOptions]="{standalone: true}">
                    <label class="custom-control-label" for="customCheck4">Images did not load</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="customCheck5" [(ngModel)]="reviewForm.difficultylevelOptions['Images were not clear']" [ngModelOptions]="{standalone: true}">
                    <label class="custom-control-label" for="customCheck5">Images were not clear
                    </label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="customCheck6" [(ngModel)]="reviewForm.difficultylevelOptions['Other']" [ngModelOptions]="{standalone: true}">
                    <label class="custom-control-label" for="customCheck6">Other</label>
                </div> -->
                <div class="buttons text-center">
                    <button class="btn emoji-btn _assessment_mr-15" type="button" [ngClass]="reviewForm.experience === 'GOOD' ? 'btn-success-light': 'btn-outline-secondary'" (click)="setExperience('GOOD')">
                        <img src="assets/img/emoji-easy-icon.svg" class="icon" />
                    </button>
                    <button class="btn emoji-btn" type="button" [ngClass]="reviewForm.experience === 'FAIR' ? 'btn-success-light': 'btn-outline-secondary'" (click)="setExperience('FAIR')">
                        <img src="assets/img/emoji-mid-icon.svg" class="icon" />
                    </button>
                    <button class="btn emoji-btn _assessment_ml-1" type="button" [ngClass]="reviewForm.experience === 'BAD' ? 'btn-success-light': 'btn-outline-secondary'" (click)="setExperience('BAD')">
                        <img src="assets/img/emoji-hard-icon.svg" class="icon" />
                    </button>
                </div>
            </div>

            <p class="text-center">How hard was the test?</p>
            <div class="d-flex justify-content-center assessment_mb-30 buttons">
                <button class="btn round-btn" type="button" [ngClass]="reviewForm.difficultyLevel === 'EASY' ? 'btn-success-light': 'btn-outline-secondary'" (click)="setDifficulty('EASY')">EASY</button>
                <button class="btn round-btn" [ngClass]="reviewForm.difficultyLevel === 'MEDIUM' ? 'btn-success-light': 'btn-outline-secondary'" (click)="setDifficulty('MEDIUM')">MEDIUM</button>
                <button class="btn round-btn" [ngClass]="reviewForm.difficultyLevel === 'HARD' ? 'btn-success-light': 'btn-outline-secondary'" (click)="setDifficulty('HARD')">HARD</button>
            </div>
            
            <div class="form-group assessment_pb-3">
                <input type="text" class="form-control feedback" placeholder="Add additional feedback here" [(ngModel)]="reviewForm.feedback" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="d-flex justify-content-start">
                <button class="btn UNFAPP-blue-btn btn-block assessment_mb-0" type="button" data-dismiss="modal" (click)="submitReview()">Submit</button>
            </div>
        </div>
    </form>
</div>
